import React from "react";

const LoadingScreen = () => {
  return (
    <div className="text-center">
      {/* Modern animated spinner with layered effect */}
      <div className="position-relative mb-4">
        <div className="spinner-border" style={{ 
          width: '3rem', 
          height: '3rem', 
          borderColor: '#0BA8CF',
          borderRightColor: 'transparent'
        }} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        {/* Pulsing ring effect */}
        <div className="position-absolute top-50 start-50 translate-middle">
          <div className="spinner-border" style={{ 
            width: '4rem', 
            height: '4rem',
            borderColor: '#0BA8CF',
            borderRightColor: 'transparent',
            opacity: 0.25
          }}></div>
        </div>
      </div>
      
      {/* Elegant loading text */}
      <div className="loading-content">
        <p className="mb-0 fs-5 fw-bold" style={{ color: '#0BA8CF' }}>Please wait while we prepare the next chapter</p>
        <div className="mt-3 d-flex justify-content-center gap-2">
          <div className="rounded-circle" style={{ 
            width: '8px', 
            height: '8px', 
            backgroundColor: '#003366',
            animation: 'pulse 1.4s ease-in-out infinite both',
            animationDelay: '-0.32s'
          }}></div>
          <div className="rounded-circle" style={{ 
            width: '8px', 
            height: '8px', 
            backgroundColor: '#003366',
            animation: 'pulse 1.4s ease-in-out infinite both',
            animationDelay: '-0.16s'
          }}></div>
          <div className="rounded-circle" style={{ 
            width: '8px', 
            height: '8px', 
            backgroundColor: '#003366',
            animation: 'pulse 1.4s ease-in-out infinite both'
          }}></div>
        </div>
      </div>
      
      {/* CSS Animation */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes pulse {
            0%, 80%, 100% {
              transform: scale(0.8);
              opacity: 0.5;
              background-color: #003366;
            }
            40% {
              transform: scale(1);
              opacity: 1;
              background-color: #04284b;
            }
          }
          
          .spinner-border {
            animation: spin 1s linear infinite;
          }
          
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `
      }} />
    </div>
  );
};

export default LoadingScreen;